<div class="container">
  <div class="col-md-12">
    <div id="Header">
      <img src="./assets/images/logo_woden.png" alt="">
    </div>
  </div>
  <div class="col-md-12">
    <h2>Agenda Filtrar</h2>
    <p-accordion>
      <p-accordionTab header="Filtro">
        <p-card>
          <form>
            <div class="row form-group">
              <div class="col-md-3">
                <label for="">Fecha Inicio</label>
                <!--<input type="text" class="form-control">-->
                <p-calendar name="stFn" [(ngModel)]="stardDateSelected"                  
                  [inputStyle]="{'width': '100%'}" showIcon="true">
                </p-calendar>
              </div>
              <div class="col-md-3">
                <label for="">Fecha Fin</label>
                <!--<input type="text" class="form-control">-->
                <p-calendar name="enFn" [(ngModel)]="endDateSelected"
                  
                  [inputStyle]="{'width': '100%'}" showIcon="true">
                </p-calendar>
              </div>
              <div class="col-md-2">
                <button class="btn btn-success btn-sm" (click)="getSchedulesFilters()" >
                  Buscar
                  <span class="fa fa-search"></span>
                </button>
              </div>
            </div>
            <!--<div class="row form-group">
              <div class="col-md-2">
                <button class="btn btn-success btn-sm" >
                  Buscar
                  <span class="fa fa-search"></span>
                </button>
              </div>
            </div>-->
          </form>
        </p-card>
      </p-accordionTab>
    </p-accordion>
  </div>
  <div class="col-md-12 table">
    <p-table #dt [columns]="cols" [value]="listScheduleSeries" [resizableColumns]="true" columnResizeMode="expand"
             [autoLayout]="true" [paginator]="true" [rows]="10" [first]="first">
      <ng-template pTemplate="caption">
        <div style="text-align: right">
          <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
          <input type="text" pInputText size="50" placeholder="Buscar"
                 (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
        <div class="p-d-flex">
          <button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV()" class="p-mr-2"
                  pTooltip="CSV" tooltipPosition="bottom"></button>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            {{rowData[col.field]}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        Total Registros: {{listScheduleSeries?.length}}
      </ng-template>
    </p-table>
  </div>
</div>
